import {
  all,
  call,
  put,
  select,
  takeEvery
} from 'redux-saga/effects'

import * as Actions from 'actions/help_center'
import * as AppActions from 'actions/app'
import * as Api from 'api/bff'
import * as Selectors from 'selectors'

const getDemosFromResponse = result => {
  if (Array.isArray(result)) {
    return result
  }

  return result?.playbooks || []
}

export function* fetchDemos() {
  try {
    const languageId = yield select(Selectors.getUserLanguageId)
    const result = yield call(Api.fetchDemos, languageId)
    const demos = getDemosFromResponse(result)

    yield put(Actions.fetchDemosSuccess(demos))
  } catch (error) {
    yield put(Actions.fetchDemosError(error))
    yield put(AppActions.genericErrorMessage())
    yield put(AppActions.exception(error))
  }
}

export default function* helpCenterSaga() {
  yield all([
    takeEvery(Actions.fetchDemosStart, fetchDemos)
  ])
}
